<template>
  <EnableFactorModalView
    v-bind="$data"
    :handleContinue="enableTOTP"
    :showModal="showModal"
    @close-modal="handleModalClose"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EnableFactorModalView from 'client/MFA/modals/EnableFactorModalView.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export default {
  name: 'EnableTotpModal',

  components: {
    EnableFactorModalView,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headerText: 'Enable Time-based One Time Password',
      kbLink: {
        href: KbArticleUrls.totpSetup,
        text: 'Learn more: TOTP',
      },
      imageData: {
        alt: 'JumpCloud TOTP',
        src: 'img/jc_totp.png',
      },
      modalText: 'MFA can be supported with Time-based One Time Password (TOTP), a simple and user-friendly way to provide an extra layer of protection. TOTP is not currently enabled for your organization.',
    };
  },

  computed: {
    ...mapState('TotpSettingsModule', ['userPortalTotpConfig']),
  },

  methods: {
    ...mapActions('TotpSettingsModule', {
      changeUserPortalTotpConfig: 'changeUserPortalTotpConfig',
      saveUserPortalTotpConfig: 'saveChanges',
    }),

    async enableTOTP() {
      const setUserPortalTotpConfig = (enabled) => (
        this.changeUserPortalTotpConfig({
          ...this.userPortalTotpConfig,
          enabled,
        })
      );

      setUserPortalTotpConfig(true);

      try {
        await this.saveUserPortalTotpConfig();
      } catch {
        setUserPortalTotpConfig(false);
      } finally {
        this.handleModalClose();
      }
    },

    handleModalClose() {
      this.$emit('close-modal');
    },
  },
};
</script>
